<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="overview">
    <div class="content">
      <div class="item" v-for="(item, index) in showData" :key="index">
        <div class="value">
          <span v-if="item.name">{{ item.name }}：</span>
          <span>{{ item.value }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="tsx">
import { computed } from 'vue';
import { getOverviewData, _testOverviewData } from './index';

const showData = computed(() => {
  return getOverviewData(_testOverviewData, false, false, false);
});
</script>
<style lang="scss" scoped>
@import './index.scss';
.content {
  padding: 0 80px;
  margin: 0 100px;
  border: 1px solid var(--theme-color-1);
  position: relative;
  &::before {
    content: '';
    position: absolute;
    width: 11px;
    height: 11px;
    background: var(--theme-color-1);
    border-radius: 50%;
    left: -5px;
    top: -5px;
  }
  &::after {
    content: '';
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, var(--theme-color-1) 0%, #ffffff 100%);
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0.1;
  }
}
.item {
  display: flex;
  align-items: center;
  padding: 36px 0;
  &:first-child {
    padding-top: 20px;
  }
  &:last-child {
    padding-bottom: 30px;
  }

  .value {
    font-size: 16px;
    color: #2b2b2b;
  }
}
</style>
